import request from '../plugins/axios.js'

// 旺旺客服二维码
export function getDimensionalCode(data) {
    return request(
        'post',
        '/jump/h5/Fetch/getDimensionalCode',
        data
    )
}